import './Speech.less';
import { useRef, useContext, useEffect, useState } from 'react';
import { EditContext } from '@/context/EditContext';
import OriginalTranslate from './originaltranslate/OriginalTranslate';
import BilingualTranslate from './bilingualtranslate/BilingualTranslate';

export default function Speech({ playState, getTimelineController }) {
  const {
    clickOutsideListener,
    setLanguageCheckShow,
    mode,
    activeTab,
    seppchScroll,
    setSeppchScroll,
    isPlaying,
    setSeppchHover,
    timelinePlaybackTime,
  } = useContext(EditContext);
  const speechMainRef = useRef(null);
  const [scrollTime, setScrollTime] = useState(null);
  useEffect(() => {
    if (clickOutsideListener) {
      if (
        !clickOutsideListener.target.closest('.translation_select_language') &&
        !clickOutsideListener.target.closest('.language_list_box')
      ) {
        setLanguageCheckShow(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clickOutsideListener]);
  useEffect(() => {
    if (!seppchScroll) {
      const speechMain = document.querySelector('.speech_scroll_main');
      const activeSentenceItem = document.querySelector('.speech_active');
      const activeSentenceHeight = activeSentenceItem ? activeSentenceItem.offsetHeight : 0;
      if (activeSentenceItem && speechMain) {
        const distanceToTop =
          activeSentenceItem.getBoundingClientRect().top - speechMain.getBoundingClientRect().top;
        if (distanceToTop < 0 || distanceToTop + activeSentenceHeight > speechMain.clientHeight) {
          speechMain.scrollTop = speechMain.scrollTop + distanceToTop; // 滚动到activeSentenceItem到subtitleMain最顶部
        }
      }
    }
  }, [document.querySelector('.speech_active'), timelinePlaybackTime, activeTab, seppchScroll]);

  const handleWheel = () => {
    if (isPlaying) {
      setSeppchScroll(true);
      setScrollTime((prevTime) => {
        clearTimeout(prevTime); // 清除之前的计时器
        return setTimeout(() => {
          setSeppchScroll(false);
        }, 2000);
      }); // 重新开始计时
    }
  };

  useEffect(() => {
    const speechMain = speechMainRef.current;
    if (speechMain) {
      speechMain.addEventListener('wheel', handleWheel);
    }
    return () => {
      if (speechMain) {
        speechMain.removeEventListener('wheel', handleWheel);
        clearTimeout(scrollTime);
        setScrollTime(null);
      }
    };
  }, [isPlaying]);
  return (
    <div className="speech_box">
      <div
        className="speech_main"
        onMouseEnter={() => {
          setSeppchHover(true);
        }}
        onMouseLeave={() => {
          setSeppchHover(false);
        }}
        ref={speechMainRef}>
        {mode !== 'translation_and_tts' && (
          <OriginalTranslate playState={playState} getTimelineController={getTimelineController} />
        )}
        {mode === 'translation_and_tts' && (
          <BilingualTranslate playState={playState} getTimelineController={getTimelineController} />
        )}
      </div>
    </div>
  );
}
